const currentYear = new Date().getFullYear();

export const months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july ',
    'august ',
    'september',
    'october',
    'november',
    'december',
];

export const years = [];

const makeYears = () => {
    for (let i = 1900; i <= currentYear; i++) {
        years.push(i.toString());
    }
};

makeYears();